import {
  GET_ECI_DUE_DATE_GROUP_REPORT,
  GET_ECI_DUE_DATE_GROUP_REPORT_SPC_COMPANY_LIST,
  GET_ECI_DUE_DATE_GROUP_REPORTS,
  POST_ECI_DUE_DATE_GROUP_REPORT,
  DELETE_ECI_DUE_DATE_GROUP_REPORT,
  GET_AVAILABLE_SPC_FOR_GROUP_REPORT,
} from "../constants/actionTypes";

const defaultState = {
  eciDueDateList: [],
  eciDueDateGroupSPCCompanyDetailsList: [],
  serviceProvider: null,
  groupReport: null,
  customers: [],
  availableSPCList: [],
  eciDueDateGroupList: [],
};

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_ECI_DUE_DATE_GROUP_REPORT:
        return {
          ...state,
          serviceProvider: action.payload?.service_provider || null,
          groupReport: action.payload?.group_report || null,
          customers: action.payload?.customers || [],
        };
      case GET_ECI_DUE_DATE_GROUP_REPORTS:
        return {
          ...state,
          eciDueDateGroupList: action.payload, // Store the complete response object
        };
      case DELETE_ECI_DUE_DATE_GROUP_REPORT:
        return {
          ...state,
          eciDueDateGroupList: (state.eciDueDateGroupList || []).filter(
            (item) => String(item?.id) !== String(action.payload),
          ),
        };
      case GET_ECI_DUE_DATE_GROUP_REPORT_SPC_COMPANY_LIST:
        return {
          ...state,
          eciDueDateGroupSPCCompanyDetailsList: action.payload
            ? action.payload
            : [],
        };
      case GET_AVAILABLE_SPC_FOR_GROUP_REPORT:
        return {
          ...state,
          availableSPCList: action.payload ? action.payload : [],
        };
      case POST_ECI_DUE_DATE_GROUP_REPORT:
        return {
          ...state,
          // Handle post response if needed
        };
      default:
        return state;
    }
  } catch (error) {
    console.error("Reducer error:", error);
    return state;
  }
};
